"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var AccountSelectionState_1 = require("./AccountSelectionState");
/** Platform UI Components */
var GridRow_1 = require("@idp/ui-components/components/containers/Grid/GridRow");
var GridColumn_1 = require("@idp/ui-components/components/containers/Grid/GridColumn");
var RadioGroup_1 = require("@idp/duc/components/atoms/RadioGroup");
var RadioButton_1 = require("@idp/duc/components/atoms/RadioGroup/components/RadioButton");
/** CMS */
var cms_integration_1 = require("@idp/cms-integration");
// import { AccountSelectionCms } from './AccountSelection.cms';
/** Stylesheets */
var utilityStyles = require("../../../styles/utilities.scss");
var appStyles = require("../../../styles/login-widget.scss");
var styles = require("./AccountSelection.scss");
/** LOB Components */
var PageLevelHeading_1 = require("../../common/PageLevelHeading");
var PageLevelHeadingProps_1 = require("../../common/PageLevelHeading/PageLevelHeadingProps");
var CtaButtonGroup_1 = require("../../common/CtaButtonGroup");
var CtaButtonGroupProps_1 = require("../../common/CtaButtonGroup/CtaButtonGroupProps");
/** Api, Reporting, Mappers, Request, Response */
var ReportingService_1 = require("../../../api/ReportingService");
var StateProvider_1 = require("../../../api/StateProvider");
var Events_1 = require("../../../api/Events");
var AccountSelection = /** @class */ (function (_super) {
    __extends(AccountSelection, _super);
    // private AccountSelectionCmsData: AccountSelectionCms;
    function AccountSelection(props) {
        var _this = _super.call(this, props) || this;
        _this.selectedItem = '';
        console.info('AccountSelection - construtor', props);
        _this.state = new AccountSelectionState_1.default();
        _this.reportingService = new ReportingService_1.default();
        _this.stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        _this.itemChanged = _this.itemChanged.bind(_this);
        _this.continueBtnEvents = _this.continueBtnEvents.bind(_this);
        return _this;
    }
    AccountSelection.prototype.componentDidMount = function () {
        console.info('componentDidMount');
        this.events = new Events_1.default([AccountSelection.accountSelectionContinueEventName]);
        if (this.props.options !== null &&
            this.props.options !== undefined &&
            this.props.options.pageLoadEvent !== null &&
            this.props.options.pageLoadEvent !== undefined &&
            this.props.options.pageLoadEvent) {
            this.analyticsAccountSelectionPageLoad();
        }
    };
    AccountSelection.prototype.analyticsAccountSelectionPageLoad = function () {
        this.reportingService
            .analyticsLoginPageLoad('isAccountSelectionPageLoadedAlready', ReportingService_1.PageUrls.ACCOUNT_SELECTION, ReportingService_1.PageName.ACCOUNT_SELECTION);
    };
    AccountSelection.prototype.itemChanged = function (value) {
        this.analyticsAccountSelectionPageLoad();
        console.log("itemSelected: value '" + value + "'");
        if (value) {
            this.setState({ disabledButton: false });
            this.selectedItem = value;
        }
    };
    AccountSelection.prototype.renderRadioGroup = function () {
        var options = [];
        for (var i = 0; i < this.props.data.accountList.length; i++) {
            var testId = "Account_Selection_Radio_Group_Accounts_" + i;
            var account = this.props.data.accountList[i];
            // SMB Accounts get labeled
            // Flagging this code as dark until we are ready to include it in 9/9 release
            var smbLabel = account.smbCustomer ?
                this.AccountSelectionCmsData.accountSelection.businessAccountRadioLabel : '';
            // options.className.label set to styles.hide prevents the value from showing
            // as the label.  The label is then included as the body of the radio button
            // with the contentChildOut set to false
            var rb = (React.createElement(RadioButton_1.default, { key: account.asmIndex, value: account.asmIndex, accessibilityText: account.maskedBan, testId: testId },
                account.maskedBan,
                " ",
                smbLabel));
            options.push(rb);
        }
        return (React.createElement(RadioGroup_1.default, { defaultChecked: "", name: "accountSelectRadioGroup", onChange: this.itemChanged, options: {
                elementsDirection: 'column',
            } }, options));
    };
    AccountSelection.prototype.continueBtnEvents = function () {
        console.log("continueClicked selectedValue is '" + this.selectedItem + "'");
        this.analyticsAccountSelectionPageLoad();
        var eventData = {
            selectedValue: this.selectedItem,
        };
        this.events.fireEvent(eventData, AccountSelection.accountSelectionContinueEventName);
    };
    AccountSelection.prototype.render = function () {
        var loginAccountSelectionTestId = 'Login_Account_Selection';
        // this.AccountSelectionCmsData = CMS.get(new AccountSelectionCms(), 'AccountSelection').content;
        this.AccountSelectionCmsData = cms_integration_1.CMS.get({}, 'login').content.loginConsole;
        return (React.createElement("div", { className: [styles.loginAccountSelectionWrapper].join(' ') },
            React.createElement(GridRow_1.default, null,
                React.createElement(GridColumn_1.default, { options: { size: 12, className: 'no-pad', customOptions: '' } },
                    React.createElement("div", { className: [utilityStyles.formRow].join(' ') },
                        React.createElement(PageLevelHeading_1.default, { data: {
                                headingText: this.AccountSelectionCmsData.common.iconHeadingTitle,
                            }, options: {
                                type: PageLevelHeadingProps_1.PageLevelHeadingType.HEADING_WITH_ICON,
                            }, testId: loginAccountSelectionTestId + '_Header' })))),
            React.createElement(GridRow_1.default, null,
                React.createElement(GridColumn_1.default, { options: {
                        size: 7,
                        className: appStyles.innerPanelContainer + ' pad-none',
                        customOptions: '',
                    } },
                    React.createElement("div", { className: [
                            utilityStyles.marTXxs,
                            utilityStyles.padTXxxs,
                            styles.signedInWith,
                        ].join(' ') },
                        React.createElement("span", null,
                            this.AccountSelectionCmsData.accountSelection.signedInWithText,
                            "\u00A0"),
                        React.createElement("span", null,
                            React.createElement("strong", null,
                                this.AccountSelectionCmsData.accountSelection.signedInWithTextUserIdLabel,
                                "\u00A0",
                                this.props.data.loggedInAccount))),
                    React.createElement("div", { className: [
                            utilityStyles.marTXs,
                        ].join(' ') },
                        React.createElement("h2", null, this.AccountSelectionCmsData.accountSelection.chooseAccountSecondaryTitle)),
                    React.createElement("div", { className: [
                            utilityStyles.marTSmAll,
                            styles.radioWrapper,
                        ].join(' ') }, this.renderRadioGroup()),
                    React.createElement("div", { className: [
                            utilityStyles.marTMdLg,
                        ].join(' ') },
                        React.createElement(CtaButtonGroup_1.default, { data: {
                                primaryBtnText: this.AccountSelectionCmsData.common.buttonPrimaryContinueCTA,
                                disabledPrimaryBtn: this.state.disabledButton,
                            }, options: {
                                type: CtaButtonGroupProps_1.CtaButtonGroupType.BUTTON_REVERSE_LEFT,
                            }, primaryBtnEvents: {
                                onClick: this.continueBtnEvents,
                            } }))))));
    };
    AccountSelection.accountSelectionContinueEventName = 'loginAccountSelectingContinueEvent';
    return AccountSelection;
}(React.Component));
exports.default = AccountSelection;
//# sourceMappingURL=AccountSelection.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/panels/AccountSelection/AccountSelection.js
// module id = 591
// module chunks = 8